import * as React from 'react'

import { Upsell } from '../Upsell'
import {
  AlertDialogSlide,
  MoreButton,
  SimpleAccordion,
  SimpleAccordionDetails,
  SimpleAccordionSummary,
} from '@sales-center/components'
import { currencyString } from '@sales-center/common'
import { useData, useHandlers } from './hooks'
import { ServiceCardProps } from './typings'
import { Details } from './Details'
import { ViewDetailsButton } from './Details/styling'
import { Container, Heading, Price, UpsellContainer } from './styled'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export function ServiceProductContents(props: ServiceCardProps) {
  const {
    service,
    index,
    onEditClick,
    disableDelete,
    deleteWarningMessage,
    entityType,
    localMode,
    readOnly,
  } = props

  const { id, name, upSell, totalFirst, description } = service

  const { dialog, detailId, setDialog, setDetailsOpen, viewDetailsButtonText } =
    useData({
      index,
      service,
      entityType,
    })

  const {
    handleAccordionChange,
    handleEditClick,
    showDeleteDialog,
    hideDeleteDialog,
    handleDeleteClick,
  } = useHandlers({
    service,
    detailId,
    localMode,
    setDialog,
    entityType,
    onEditClick,
    disableDelete,
    setDetailsOpen,
  })
  const theme = useTheme()
  return (
    <>
      <AlertDialogSlide
        open={dialog === 'delete'}
        title="Delete Service"
        message="Are you sure you want to delete this service?"
        okButtonText="Delete"
        okClick={handleDeleteClick}
        cancelClick={hideDeleteDialog}
      >
        <Typography variant="body1" color="#190734">
          The service will be removed from any agreements in Draft and In
          Progress status.
        </Typography>
      </AlertDialogSlide>

      <AlertDialogSlide
        open={dialog === 'noDelete'}
        title="Cannot Delete Service"
        message={deleteWarningMessage}
        cancelClick={hideDeleteDialog}
        disableDelete={true}
      />

      <Container container direction="row" flexWrap="nowrap" p="12px 0 0 12px">
        <Grid item flexGrow={2}>
          <Heading>
            {`${name} - ${description} `}
            <UpsellContainer>
              {upSell && <Upsell fontSize="14px" inline />}
            </UpsellContainer>
          </Heading>
          Total <Price>${currencyString(totalFirst)}</Price>
          <SimpleAccordion square onChange={handleAccordionChange}>
            <SimpleAccordionSummary>
              <ViewDetailsButton>{viewDetailsButtonText}</ViewDetailsButton>
            </SimpleAccordionSummary>
            <SimpleAccordionDetails>
              <Details {...props} />
            </SimpleAccordionDetails>
          </SimpleAccordion>
        </Grid>

        {!readOnly && (
          <Grid item display="flex" alignItems="start" flexGrow={0}>
            <MoreButton
              dataTestId={`serviceMoreBtn-${id}`}
              style={{ marginLeft: theme.spacing(1.5), top: '18px' }}
              options={[
                {
                  label: 'Edit',
                  onClick: handleEditClick,
                  dataTestId: 'editBtn',
                },
                {
                  label: 'Delete',
                  onClick: showDeleteDialog,
                  dataTestId: 'deleteBtn',
                },
              ]}
            />
          </Grid>
        )}
      </Container>
    </>
  )
}
